<!-- Main Footer -->
<footer class="main-footer">
    <!-- To the right 
    <div class="float-right d-none d-sm-inline">
        Anything you want
    </div>-->
    <!-- Default to the left -->
    <strong class="float-right d-none d-sm-inline">Copyright &copy; <a href="https://tecsolutions.com.ar">tecsolutions.com.ar</a></strong> 
</footer>